<template>
  <div
    class="add-bi-dropdown-container"
    v-click-outside="
      () => {
        onChangeActive(false);
      }
    "
  >
    <div class="add-bi-dropdown-wrp" @click="onChangeActive(!isActive)" :class="{ active: isActive }">
      <div class="add-bi-dropdown-text-list">{{ isSelectAll ? t('bi.All') : dropdownSelect.toString() }}</div>
    </div>
    <div class="arrow-dropdown">
      <down-ward-icon :class="{ active: isActive }" />
    </div>
    <div class="add-bi-dropdown-item-wrp" :class="{ active: isActive }">
      <div class="add-bi-dropdown-item" v-for="item in options" :key="item.label">
        <div class="form-check">
          <input
            class="form-check-input"
            :id="name + '-' + item.label + '-' + item.value"
            type="checkbox"
            :value="item.value"
            @input="onChangeOption"
          />
          <div class="form-check-label font-f3" for="flexCheckDefault">{{ item.label }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
//libs
import { useI18n } from 'vue-i18n';

import DownWardIcon from '@/assets/icons/base/v-select/DownWardIcon.vue';

//directive
import { clickOutside as vClickOutside } from '@/views/components/segment-tabs/components/MenuItem/hooks/directive';

import useAddBiDropDown from './hooks/useAddBiDropdown';

interface Option {
  label: string;
  value: string | number;
}

interface Props {
  options: Option[];
  dropdownSelect: string[];
  name: string;
}

defineEmits(['on-select']);

const { t } = useI18n();

const props = defineProps<Props>();

const { isSelectAll, isActive, onChangeActive, onChangeOption } = useAddBiDropDown(props);
</script>

<style lang="scss" scoped>
@import '@/assets/styles/modules/analytics/bi/analytics-add-bi-dropdown.scss';
</style>
